import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { readSessionFromHash } from '../utils';

const useSyncSession = () => {
  const history = useHistory();
  const [session] = useState(readSessionFromHash);

  useEffect(() => {
    if (!session) return;

    history.replace(`${window.location.pathname}${window.location.search}`);
  }, [history, session]);

  return session;
};

export default useSyncSession;
